import { OrderTypes } from '@/constants';

export const queryParamsInitial = {
  page: 1,
  limit: 10,
  sortKey: 'id',
  filters: [],
  sortDirection: OrderTypes.Desc,
  isShowDeletedItems: false,
};

export const statusOptions = {
  ACTIVE: 'Active',
  WAIT_ACCEPT: 'Wait accept',
  DELETED: 'Deleted',
};

export const instructionTypeForFilter = {
  filterId: 'array',
  filterEmail: 'string',
  filterPartnerClientAccountId: 'number',
};
